<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {},
};
</script>

<style>
/* 将阿里的字休引进来 */
@import url('../src/assets/iconFont/iconfont.css');
* {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial,
    sans-serif;
}

.demo-table-info-cell-value {
  color: red;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

.date-picker input {
  color: #fff;
  background-color: #2db7f5;
  border-color: #2db7f5;
}
</style>
